<template>
  <div>
    <base-header type="gradient-warning" class="pb-6 pb-8 pt-5 pt-md-8">
      <!-- Card stats -->
      <div class="row">
        <!-- Chamadas ativas -->
        <div class="col-lg-4 d-flex align-items-stretch">
          <stats-card
            title="Chamadas ativas"
            type="gradient-blue"
            :sub-title="
              String(
                stats['Aceleração'].regularCalls +
                  stats['Pré-aceleração'].regularCalls
              )
            "
            icon="ni ni-planet"
            class="mb-4 mb-xl-0 flex-grow-1"
          >
            <template slot="footer">
              <span class="text-wrap">
                de um total de
                <base-dropdown>
                  <span slot="title" class="dropdown-toggle">
                    <span class="font-weight-bold text-warning">
                      {{
                        stats["Aceleração"].totalCalls +
                        stats["Pré-aceleração"].totalCalls
                      }}
                    </span>
                    chamadas
                  </span>
                  <span class="dropdown-item"
                    >Aceleração:
                    <span class="font-weight-bold rounded border py-1 px-2">{{
                      stats["Aceleração"].totalCalls || 0
                    }}</span></span
                  >
                  <span class="dropdown-item"
                    >Pré-aceleração:
                    <span class="font-weight-bold rounded border py-1 px-2">{{
                      stats["Pré-aceleração"].totalCalls || 0
                    }}</span></span
                  >
                </base-dropdown>
              </span>
            </template>
          </stats-card>
        </div>
        <!-- Média inscrições aceleração -->
        <div class="col-lg-4 d-flex align-items-stretch">
          <stats-card
            title="Inscrições aceleração"
            type="gradient-red"
            :sub-title="String(stats['Aceleração'].subscriptionsAvg)"
            icon="ni ni-spaceship"
            class="mb-4 mb-xl-0 flex-grow-1"
          >
            <template slot="footer">
              <span class="text-wrap">startups em média por chamada</span>
            </template>
          </stats-card>
        </div>
        <!-- Média inscrições pré-aceleração -->
        <div class="col-lg-4 d-flex align-items-stretch">
          <stats-card
            title="Inscrições pré-aceleração"
            type="gradient-green"
            :sub-title="String(stats['Pré-aceleração'].subscriptionsAvg)"
            icon="fas fa-paper-plane"
            class="mb-4 mb-xl-0 flex-grow-1"
          >
            <template slot="footer">
              <span class="text-wrap">startups em média por chamada</span>
            </template>
          </stats-card>
        </div>
      </div>
    </base-header>

    <div class="container-fluid mt--7">
      <div class="row">
        <div class="col">
          <chamadas-table
            title="Chamadas para startups STARS"
            @calculatedStats="updateStats"
          ></chamadas-table>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ChamadasTable from "./Chamadas/ChamadasTable";
export default {
  name: "chamadas",
  components: {
    ChamadasTable,
  },
  data() {
    return {
      stats: {
        // eslint-disable-next-line prettier/prettier
        "Aceleração": {
          totalCalls: 0,
          regularCalls: 0,
          subscriptionsAvg: 0,
        },
        "Pré-aceleração": {
          totalCalls: 0,
          regularCalls: 0,
          subscriptionsAvg: 0,
        },
      },
    };
  },
  methods: {
    updateStats(stats) {
      Object.assign(this.stats, stats);
    },
  },
};
</script>
<style></style>
